import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaPlus, FaMinus, FaEdit, FaTrash, FaUsers } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import AddIcon from "@mui/icons-material/Add";
import bookmark from "../../assets/img/3.png";
import Avatar from "@mui/material/Avatar";
import Fab from "@mui/material/Fab";
import $ from "jquery";
import RefreshIcon from "@mui/icons-material/Refresh";
import Select from "react-select";
import HighLighter from "../layout/HighLighter";
import CommentTextareaModal from "../layout/CommentTextareaModal";
import ConfirmDialog from "../layout/ConfirmDialog";
import { useComments } from "../../hooks/useComments";
const TagPeople = [
  { value: "Everyone", label: "Everyone" },
  { value: "Users", label: "Users" },
];

const userlistDataEmpty = [{ value: "Please wait..", label: "Please wait.." }];

const FAQData = [
  {
    question: "What is the weather like today?",
    answer:
      "I'm sorry, I cannot provide real-time weather information. Please check a weather website or app for the current weather.",
  },
  {
    question: "How do I reset my password?",
    answer:
      "To reset your password, go to the 'Forgot Password' page on our website and follow the instructions provided. You'll receive an email with a link to reset your password.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept various payment methods, including credit cards, PayPal, and bank transfers. You can find a list of accepted payment methods on our website during the checkout process.",
  },
  {
    question: "How do I return a product?",
    answer:
      "To return a product, log in to your account, go to the 'Order History' section, and follow the instructions for initiating a return. Make sure to check our return policy for eligibility and further details.",
  },
  {
    question: "Do you offer international shipping ?",
    answer:
      "Yes, we offer international shipping to many countries. Shipping fees and delivery times may vary depending on your location. You can check the available shipping options during the checkout process.",
  },
];
const SlidingPanel = (props) => {
  const {
    fetchPosts,
    fetchUserEmailsByGroup,
    fetchFaqs,
    createTopic,
    createComment,
    updateComment,
    deleteComment,
  } = useComments();
  const [open, setOpen] = useState(false);
  const [openReply, setopenReply] = useState(false);
  const [openEditReply, setopenEditReply] = useState(false);
  const [openEditPost, setopenEditPost] = useState(false);

  const [name, setName] = useState("");
  const [postView, setPostView] = useState({});
  const [commentVisibility, setCommentVisibility] = useState({});
  const [PostTopicMessage, setPostTopicMessage] = useState("");
  const [PostTopicReplayMessage, setPostTopicReplayMessage] = useState("");
  const [PostTopicEditMessage, setPostTopicEditMessage] = useState("");
  const [ReplyTopicEditMessage, setReplyTopicEditMessage] = useState("");

  const [parentId, setparentId] = useState();
  const [topicid, settopicid] = useState();
  const [EditPostId, setEditPostId] = useState();
  const [EditPostReplyId, setEditPostReplyId] = useState();
  const [DeleteConfirm, setDeleteConfirm] = useState(false);
  const [DeleteId, setDeleteId] = useState();
  const [LoadingReplay, setLoadingReplay] = useState(false);
  const [tabValue, setTabValue] = useState("tab1"); // Initialize with 'tab1' as the default tab
  const [isrefreshing, setisrefreshing] = useState(false);
  const [UserTypeComments, setUserTypeComments] = useState(TagPeople[0]); // Set the default value to the first option
  const [openState, setOpenState] = useState(Array(FAQData.length).fill(false));
  const [FaqsList, setFaqsList] = useState([]);
  const [selectedTagUsers, setselectedTagUsers] = useState([]);
  const [TagUsersData, setTagUsersData] = useState([]);
  const [userlistData, setuserlistData] = useState([]);

  const handleClose = () => {
    setOpen(false);
    setImagePreviews([]);
    setselectedTagUsers([]);
    setUserTypeComments(TagPeople[0]);
    setPostTopicMessage("");
    setTagUsersData([]);
    setLoadingReplay(false);
  };

  const handleCloseReplay = () => {
    setopenReply(false);
    setPostTopicReplayMessage("");
  };

  const handleClosePostEdit = () => {
    setopenEditPost(false);
    setPostTopicEditMessage("");
  };

  const handleCloseReplyEdit = () => {
    setopenEditReply(false);
    setReplyTopicEditMessage("");
  };

  const [postComments, setPostComments] = useState([]);

  const email = localStorage.getItem("myemail");
  const typeofuser = localStorage.getItem("userType");
  const userInfo = { given_name: localStorage.getItem("userName"), email };

  useEffect(() => {
    GetuserLists();
    if (props.guid !== undefined) {
      GetFaqsLsit();
      GetSaveReports();
      viewNotificationsReply();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const GetSaveReports = async () => {
    setisrefreshing(true);
    try {
      const jsonData = await fetchPosts(props.guid);
      const postData = jsonData.data.posts;
      const newArray = postData.filter((item) => item !== null);

      setPostComments(newArray);
      setisrefreshing(false);
    } catch (err) {
      console.error("Error:", err);
      setPostComments([]);
      setisrefreshing(false);
    }
  };

  const GetuserLists = async () => {
    try {
      const postData = await fetchUserEmailsByGroup();
      setuserlistData(postData);
    } catch (err) {
      console.error("Error:", err);
      setuserlistData([]);
    }
  };

  const GetFaqsLsit = async () => {
    try {
      const jsonData = await fetchFaqs(props.reportId, props.groupId);
      setFaqsList(jsonData);
    } catch (err) {
      console.error("Error:", err);
      setFaqsList([]);
    }
  };

  function formatDate(date) {
    const dateObj = new Date(date);

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      dateObj
    );
    return formattedDate;
  }

  const viewNotificationsReply = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const notificationID = searchParams.get("notificationiD");

    if (notificationID !== null || notificationID !== undefined) {
      setPostView((prevPostView) => ({
        ...prevPostView,
        [notificationID]: !prevPostView[notificationID],
      }));

      const toggleElement = document.getElementById(
        `postDataid_${notificationID}`
      );
      if (toggleElement) {
        $(toggleElement).slideToggle(350);
        const toggleElement_new = document.getElementById(
          `Level_1_postDataid_${notificationID}`
        );
        if (toggleElement_new) {
          var firstChild = toggleElement_new.firstElementChild;
          var idParts = firstChild.id.split("-");
          var number = idParts[idParts.length - 1];
          setCommentVisibility((prevVisibility) => ({
            ...prevVisibility,
            [number]: !prevVisibility[number],
          }));

          setPostView((prevPostView) => ({
            ...prevPostView,
            [notificationID]: !prevPostView[notificationID],
          }));
        }
      }

      setCommentVisibility((prevVisibility) => ({
        ...prevVisibility,
        [notificationID]: !prevVisibility[commentId],
      }));
    }
  };

  useEffect(() => {
    viewNotificationsReply();
  }, [isrefreshing]); // eslint-disable-line react-hooks/exhaustive-deps

  const ViewMainPostReply = (id) => {
    setPostView((prevPostView) => ({
      ...prevPostView,
      [id]: !prevPostView[id],
    }));
    const toggleElement = document.getElementById(`postDataid_${id}`);
    if (toggleElement) {
      $(toggleElement).slideToggle(350);
    }
  };

  const toggleReplyVisibility = (commentId) => {
    setCommentVisibility((prevVisibility) => ({
      ...prevVisibility,
      [commentId]: !prevVisibility[commentId],
    }));
  };

  const repliesComment = (id, name, topic) => {
    setName(name);
    settopicid(topic);
    setparentId(id);
    setopenReply(true);
  };

  const RenderReplies = ({ replies, id, depth = 2 }) => {
    if (!replies || replies.length === 0) return null;

    return (
      <div className="mt-3 ml-10 space-y-3 border-l-2 border-gray-100 pl-3">
        {replies.map((reply, replyindex) => (
          <div
            key={replyindex}
            id={`Level-${replyindex}_reply-${reply.commentId}`}
            className="flex items-start gap-2.5"
          >
            <Avatar
              sx={{ width: 26, height: 26, bgcolor: "#e8edf7", fontSize: 10, fontWeight: 700, color: "#253978", flexShrink: 0 }}
            >
              {reply.author.charAt(0).toUpperCase()}
            </Avatar>

            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-0.5">
                <span className="text-xs font-bold text-[#253978] capitalize">
                  {findUsernameFromGmail(reply.author)}
                </span>
                {reply.author === email && (
                  <div className="flex items-center gap-3">
                    <button onClick={() => EditPostReplayTopic(reply.commentId, reply.text)}>
                      <FaEdit className="text-[#253978] hover:text-blue-700 text-[10px]" />
                    </button>
                    <button onClick={() => DeletePoup(reply.commentId)}>
                      <FaTrash className="text-red-400 hover:text-red-600 text-[10px]" />
                    </button>
                  </div>
                )}
              </div>

              <p className="text-xs text-gray-700 break-words leading-relaxed">{reply.text}</p>
              <p className="text-[10px] text-gray-400 mt-0.5">{formatDate(reply.createdDateTime)}</p>

              {depth !== 0 && (
                <div className="flex items-center gap-3 mt-1.5">
                  <button
                    className="text-[11px] font-semibold text-[#253978] hover:underline"
                    onClick={() => repliesComment(reply.commentId, reply.author, reply.topicId)}
                  >
                    Reply
                  </button>
                  {reply.replies.length > 0 && (
                    <button
                      className="text-[11px] font-semibold text-[#253978] hover:underline"
                      onClick={() => toggleReplyVisibility(reply.commentId)}
                    >
                      {commentVisibility[reply.commentId]
                        ? "Hide"
                        : `${reply.replies.length} ${reply.replies.length === 1 ? "reply" : "replies"}`}
                    </button>
                  )}
                </div>
              )}

              {commentVisibility[reply.commentId] && (
                <RenderReplies
                  id={`nested-reply-${reply.commentId}`}
                  replies={reply.replies}
                  depth={depth - 1}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const PostTopic = () => {
    if (PostTopicMessage === "") return false;

    setLoadingReplay(true);
    const email = localStorage.getItem("myemail");
    const data = {
      topicIdentifier: props.guid,
      email: email,
      reportId: props.reportId,
      subject: PostTopicMessage,
      userGroupId: props.groupId,
      accessEmails:
        JSON.stringify(TagUsersData) === JSON.stringify([]) ? [] : TagUsersData,
      notifierEmails:
        JSON.stringify(TagUsersData) === JSON.stringify([])
          ? ["Everyone"]
          : TagUsersData,
      type:
        JSON.stringify(TagUsersData) === JSON.stringify([]) ? "NORMAL" : "RES",
      pageName: props.pageName,
    };

    createTopic(data)
      .then(() => {
        GetSaveReports();
        setLoadingReplay(false);
        // Close and fully reset the Post Your Comment dialog
        setOpen(false);
        setPostTopicMessage("");
        setselectedTagUsers([]);
        setTagUsersData([]);
        setUserTypeComments(TagPeople[0]);
      })
      .catch(() => {
        setLoadingReplay(false);
      });
  };

  const handleChangeTagUsers = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setselectedTagUsers(selectedOptions);
    const userGroupsArray = selectedValues.map((value) => value);
    setTagUsersData(userGroupsArray);
  };

  const PostReplyTopic = () => {
    if (PostTopicReplayMessage === "") return false;
    setLoadingReplay(true);
    const email = localStorage.getItem("myemail");
    const data = {
      topicIdentifier: props.guid,
      email: email,
      subject: PostTopicReplayMessage,
      parentCommentId: parentId,
      topicId: topicid,
    };

    createComment(data)
      .then(() => {
        GetSaveReports();
        setopenReply(false);
        setLoadingReplay(false);
        setPostTopicReplayMessage("");
      })
      .catch(() => {
        alert("Error");
        setLoadingReplay(false);
      });
  };

  const findUsernameFromGmail = (gmailAddress) => {
    const parts = gmailAddress.split("@");
    if (parts.length === 2) {
      const usernameWithDot = parts[0]; // e.g., "nabasundar.rout"
      const usernameParts = usernameWithDot.split("."); // Split by dot
      if (usernameParts.length >= 1) {
        const username = usernameParts[0]; // Get the first part before the dot
        return username;
      }
    }
    return "Invalid Gmail address";
  };

  const EditPostTopic = (id, text) => {
    setEditPostId(id);
    setopenEditPost(!openEditPost);
    setPostTopicEditMessage(text);
  };

  const EditPostReplayTopic = (id, text) => {
    setEditPostReplyId(id);
    setopenEditReply(!openEditReply);
    setReplyTopicEditMessage(text);
  };

  const PostTopicEdit = () => {
    if (PostTopicEditMessage === "") return false;
    setLoadingReplay(true);
    const data = {
      topicIdentifier: props.guid,
      subject: PostTopicEditMessage,
      commentId: EditPostId,
      userGroupId: props.groupId,
    };

    updateComment(data)
      .then(() => {
        GetSaveReports();
        setopenEditPost(false);
        setLoadingReplay(false);
        setPostTopicEditMessage("");
      })
      .catch((error) => {
        console.log(error);
        alert("Error");
        setLoadingReplay(false);
      });
  };

  const PostReplyEdit = () => {
    if (ReplyTopicEditMessage === "") return false;
    setLoadingReplay(true);
    const data = {
      topicIdentifier: props.guid,
      subject: ReplyTopicEditMessage,
      commentId: EditPostReplyId,
      userGroupId: props.groupId,
    };

    updateComment(data)
      .then(() => {
        GetSaveReports();
        setopenEditReply(false);
        setLoadingReplay(false);
        setReplyTopicEditMessage("");
      })
      .catch(() => {
        alert("Error");
        setLoadingReplay(false);
      });
  };

  const PostReplyDelete = () => {
    setLoadingReplay(true);

    const data = {
      topicIdentifier: props.guid,
      commentId: DeleteId,
    };

    deleteComment(data)
      .then(() => {
        GetSaveReports();
        setDeleteConfirm(false);
        setLoadingReplay(false);
      })
      .catch(() => {
        alert("Error");
        setDeleteConfirm(false);
      });
  };

  const DeletePoup = (id) => {
    setDeleteId(id);
    setDeleteConfirm(!DeleteConfirm);
  };

  const ChangeTab = (data) => {
    setTabValue(data);
  };
  const [imagePreviews, setImagePreviews] = useState([]); // eslint-disable-line no-unused-vars

  const toggleFaqsbtn = (index) => {
    const updatedOpenState = [...openState];
    updatedOpenState[index] = !updatedOpenState[index];
    setOpenState(updatedOpenState);
  };

  const convertToLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(
      urlRegex,
      (url) =>
        `<a class="faqslinks" href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
    );
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const commentId = searchParams.get("commentId");
  const replyId = searchParams.get("replyId");

  if (commentId !== null) {
    const toggleElement1 = document.getElementById(`postDataid_${commentId}`);

    if (toggleElement1 !== null) {
      $("#main").css("marginRight", "400px");
      $("#NotificationsIdValues").css("display", "block");
      $(`#postDataid_${commentId}`).css("display", "block");

      if (replyId !== null) {
        $(`#postDataid_${commentId}`).css("display", "block");
        $(`#nested-reply-${replyId}`).css("display", "block");
      }
    }
  }

  return (
    <>
      {/* ── panel wrapper ── */}
      <div className="flex flex-col bg-gray-50" style={{ height: "100%", overflow: "hidden" }}>

        {/* ── header ── */}
        <div
          className="flex items-center justify-between px-4 py-3 text-white flex-shrink-0"
          style={{ background: "var(--app-ai-assistant-gradient, linear-gradient(135deg,#253978,#1a2a5e))" }}
        >
          <span className="font-bold text-sm tracking-wide">Comments &amp; FAQ</span>
          <button
            onClick={GetSaveReports}
            className="flex items-center justify-center w-7 h-7 rounded-full transition-all"
            style={{ background: "rgba(255,255,255,0.12)" }}
            title="Refresh"
          >
            {isrefreshing ? (
              <span className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <RefreshIcon sx={{ fontSize: 16, color: "white" }} />
            )}
          </button>
        </div>

        {/* ── tabs ── */}
        <div className="flex border-b border-gray-200 bg-white flex-shrink-0">
          {[
            { id: "tab1", label: "Comments", count: postComments.length },
            { id: "tab2", label: "FAQ", count: FaqsList.length },
          ].map(({ id, label, count }) => (
            <button
              key={id}
              onClick={() => ChangeTab(id)}
              className={`flex-1 py-2.5 text-xs font-semibold tracking-wide transition-all border-b-2 ${
                tabValue === id
                  ? "border-[#253978] text-[#253978]"
                  : "border-transparent text-gray-400 hover:text-gray-600"
              }`}
            >
              {label}
              {count > 0 && (
                <span
                  className={`ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold ${
                    tabValue === id
                      ? "bg-[#253978] text-white"
                      : "bg-gray-100 text-gray-500"
                  }`}
                >
                  {count}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* ── scrollable body ── */}
        <div className="flex-1 min-h-0 overflow-y-auto">

          {/* ══ COMMENTS TAB ══ */}
          {tabValue === "tab1" && (
            <>
              {postComments.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
                  <img width={100} src={bookmark} alt="empty" className="opacity-40 mb-4" />
                  <p className="text-gray-500 font-semibold text-sm">No Comments Yet</p>
                  <p className="text-gray-400 text-xs mt-1">
                    Be the first to start the conversation
                  </p>
                </div>
              ) : (
                <div className="divide-y divide-gray-100">
                  {postComments.map((post, postindex) => (
                    <div
                      key={postindex}
                      id={`topic_id_${post.topicId}`}
                      className="bg-white px-4 py-4"
                    >
                      {/* post header */}
                      <div className="flex items-start gap-3">
                        <Avatar
                          sx={{
                            width: 34, height: 34,
                            bgcolor: "#253978", fontSize: 12, fontWeight: 700,
                            flexShrink: 0,
                          }}
                        >
                          {post.author.charAt(0).toUpperCase()}
                        </Avatar>

                        <div className="flex-1 min-w-0">
                          <div className="flex items-center justify-between mb-0.5">
                            <span className="text-sm font-bold text-[#253978] capitalize">
                              {findUsernameFromGmail(post.author)}
                            </span>
                            {(post.author === email || typeofuser === "Admin") && (
                              <div className="flex items-center gap-3">
                                {post.author === email && typeofuser === "Admin" && (
                                  <button onClick={() => EditPostTopic(post.commentId, post.text)}>
                                    <FaEdit className="text-[#253978] hover:text-blue-700 text-xs cursor-pointer" />
                                  </button>
                                )}
                                {typeofuser === "Admin" && (
                                  <button onClick={() => DeletePoup(post.commentId)}>
                                    <FaTrash className="text-red-400 hover:text-red-600 text-xs cursor-pointer" />
                                  </button>
                                )}
                              </div>
                            )}
                          </div>

                          {/* message */}
                          <p className="text-sm text-gray-700 break-words leading-relaxed">
                            <HighLighter text={post.taggedUsers} />
                            <span> {post.text}</span>
                          </p>

                          {/* meta */}
                          <p className="text-[11px] text-gray-400 mt-1">
                            {formatDate(post.createdDateTime)}
                          </p>

                          {/* actions */}
                          <div className="flex items-center gap-4 mt-2">
                            <button
                              className="text-xs font-semibold text-[#253978] hover:underline"
                              onClick={() => repliesComment(post.commentId, post.author, post.topicId)}
                            >
                              Reply
                            </button>
                            {post.replies.length > 0 && (
                              <button
                                className="text-xs font-semibold text-[#253978] hover:underline"
                                id={`postView_${post.topicId}`}
                                onClick={() => ViewMainPostReply(post.topicId)}
                              >
                                {postView[post.topicId]
                                  ? "Hide replies"
                                  : `${post.replies.length} ${post.replies.length === 1 ? "reply" : "replies"}`}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* replies */}
                      <div
                        id={`postDataid_${post.topicId}`}
                        className={postView[post.topicId] ? "" : "hideView"}
                      >
                        <RenderReplies
                          id={`postDataid_${post.topicId}`}
                          replies={post.replies}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {/* ══ FAQ TAB ══ */}
          {tabValue === "tab2" && (
            <div className="p-3">
              {FaqsList.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
                  <img width={100} src={bookmark} alt="empty" className="opacity-40 mb-4" />
                  <p className="text-gray-500 font-semibold text-sm">No FAQs Available</p>
                  <p className="text-gray-400 text-xs mt-1">
                    No FAQ has been added for this report yet.
                  </p>
                </div>
              ) : (
                <div className="space-y-2">
                  {FaqsList.map((item, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-xl border border-gray-100 overflow-hidden shadow-sm"
                    >
                      <button
                        className="w-full flex items-center justify-between px-4 py-3 text-left"
                        onClick={() => toggleFaqsbtn(index)}
                      >
                        <span className="text-sm font-semibold text-[#253978] pr-4">
                          {item.question}
                        </span>
                        <span
                          className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full transition-colors"
                          style={{
                            background: openState[index] ? "#253978" : "#f3f4f6",
                          }}
                        >
                          {openState[index]
                            ? <FaMinus style={{ fontSize: 8, color: "white" }} />
                            : <FaPlus style={{ fontSize: 8, color: "#6b7280" }} />}
                        </span>
                      </button>
                      {openState[index] && (
                        <div
                          className="px-4 pb-4 text-sm text-gray-600 leading-relaxed border-t border-gray-50"
                          dangerouslySetInnerHTML={{ __html: convertToLinks(item.answer) }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <CommentTextareaModal
        open={open}
        title="Post Your Comment"
        onClose={handleClose}
        onSubmit={PostTopic}
        value={PostTopicMessage}
        onChange={(e) => setPostTopicMessage(e.target.value)}
        loading={LoadingReplay}
        submitLabel="Post Your Topic"
        loadingLabel="Posting..."
        authorName={userInfo?.given_name}
        authorEmail={userInfo?.email}
      >
        {/* audience type + tag users */}
        <div className="flex flex-wrap items-center gap-3 mb-3">
          <div className="flex items-center gap-2">
            <FaUsers style={{ fontSize: "18px", color: "#253978" }} />
            <Select
              options={TagPeople}
              required
              placeholder="Select Types"
              className="tagPeoples"
              value={UserTypeComments}
              onChange={(selectedOption) => setUserTypeComments(selectedOption)}
            />
          </div>
        </div>

        {UserTypeComments.value === "Users" && (
          <div className="mb-3">
            <Select
              options={userlistData.length !== 0 ? userlistData : userlistDataEmpty}
              isMulti
              required
              placeholder="Select Users"
              className="tagusers"
              value={selectedTagUsers}
              onChange={handleChangeTagUsers}
            />
          </div>
        )}
      </CommentTextareaModal>

      <CommentTextareaModal
        open={openReply}
        title={`Reply to ${findUsernameFromGmail(name)}`}
        onClose={handleCloseReplay}
        onSubmit={PostReplyTopic}
        value={PostTopicReplayMessage}
        onChange={(e) => setPostTopicReplayMessage(e.target.value)}
        loading={LoadingReplay}
        submitLabel="Reply on Topic"
        loadingLabel="Replying..."
        authorName={userInfo?.given_name}
        authorEmail={userInfo?.email}
      />

      <CommentTextareaModal
        open={openEditPost}
        title="Edit Your Post Comment"
        onClose={handleClosePostEdit}
        onSubmit={PostTopicEdit}
        value={PostTopicEditMessage}
        onChange={(e) => setPostTopicEditMessage(e.target.value)}
        loading={LoadingReplay}
        submitLabel="Update Your Post"
        loadingLabel="Updating..."
        authorName={userInfo?.given_name}
        authorEmail={userInfo?.email}
      />

      <CommentTextareaModal
        open={openEditReply}
        title="Edit Your Comment"
        onClose={handleCloseReplyEdit}
        onSubmit={PostReplyEdit}
        value={ReplyTopicEditMessage}
        onChange={(e) => setReplyTopicEditMessage(e.target.value)}
        loading={LoadingReplay}
        submitLabel="Update"
        loadingLabel="Updating..."
        authorName={userInfo?.given_name}
        authorEmail={userInfo?.email}
      />

      <ConfirmDialog
        open={DeleteConfirm}
        title="Delete Comment"
        message="Are you sure you want to delete this conversation? This action is irreversible."
        confirmLabel="Yes, Delete"
        loadingLabel="Removing..."
        loading={LoadingReplay}
        onConfirm={PostReplyDelete}
        onClose={() => setDeleteConfirm(false)}
      />

      {tabValue === "tab1" && (
        <Fab
          onClick={() => setOpen(!open)}
          className="floatingAddcomments"
          size="small"
          color="secondary"
          aria-label="add"
        >
          <AddIcon />
        </Fab>
      )}
    </>
  );
};

export default SlidingPanel;
